export default "__VITE_ASSET__Cf05ozUW__"